import { render, staticRenderFns } from "./InfocabPromotion.vue?vue&type=template&id=5099f671&scoped=true"
import script from "./InfocabPromotion.vue?vue&type=script&lang=js"
export * from "./InfocabPromotion.vue?vue&type=script&lang=js"
import style0 from "./InfocabPromotion.vue?vue&type=style&index=0&id=5099f671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099f671",
  null
  
)

export default component.exports